import React, { useState, useEffect } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { FormControl, InputLabel, Select, MenuItem, TextField, FormHelperText } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { setSyncService, getSyncService } from '../../Utils/actions/yh'

const SyncServiceDialog = ({ open, onClose }) => {

    const {
        rigWellData,
        wellProviderData,
    } = useSelector((state) => state.yh);
    const dispatch = useDispatch();
    const initialState = {
        rig: "",
        well: "",
        dataProvider: '',
        endPointType: '',
        host: '',
        port: "",
        clientId: "",
        apiKey: '',
        isSecure: '',
        url: '',
        userName: '',
        password: '',
        version: '',
        dateFormat: ''
    };

    const [dropdownRig, setDropdownRig] = useState("");
    const [selectedWell, setSelectedWell] = useState("");
    const [selectedDataProvider, setSelectedDataProvider] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [EndPoint, setEndPoint] = useState(initialState);

    const EndPointType = ['YellowHammer', 'WITSML'];
    const Secure = ['True', 'False'];
    const Version = ['1.3.1.1', '1.4.1.1'];
    const DateFormat = ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ'];

    const handleRigChange = (event) => {
        setDropdownRig(event.target.value);
        setSelectedWell("");
        setSelectedDataProvider("");
    };

    const handleWellChange = (event) => {
        setSelectedWell(event.target.value);
        setSelectedDataProvider("");
    };

    const handleDataProviderChange = (event) => {
        setSelectedDataProvider(event.target.value);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setEndPoint(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };


    useEffect(() => {
        setEndPoint(prevState => ({
            ...prevState,
            rig: dropdownRig,
            well: selectedWell,
            dataProvider: selectedDataProvider
        }))
    }, [dropdownRig, selectedWell, selectedDataProvider]);

    const commonSx = {
        width: "180px",
        marginRight: "4px",
        "& .MuiInputBase-root": {
            overflow: "hidden",
            height: "35px",
            position: "relative",
            marginBottom: "10px",
        },
        "& .MuiPickersToolbar-root": {
            minHeight: "24px",
        },
        '& .MuiInputLabel-root[data-shrink="true"]': {
            top: "0px",
        },
        '& .MuiInputLabel-root[data-shrink="false"]': {
            top: "-8px",
        },
    };

    const handleSave = () => {
        setFormSubmitted(true);

        const isRequiredFieldEmpty = EndPoint.endPointType === "YellowHammer"
            ? !EndPoint.host || !EndPoint.port || !EndPoint.clientId || !EndPoint.apiKey || !EndPoint.isSecure
            : !EndPoint.version || !EndPoint.url || !EndPoint.userName || !EndPoint.password;

        if (dropdownRig && selectedWell && selectedDataProvider && EndPoint.endPointType && !isRequiredFieldEmpty) {
            dispatch(setSyncService(EndPoint));
            if (onClose) {
                onClose();
                dispatch(getSyncService(10, 0))
            }
        }

    };

    useEffect(() => {
        if (open) {
            setFormSubmitted(false);
            setDropdownRig("");
            setSelectedWell("");
            setSelectedDataProvider("");
            setEndPoint(initialState);
        }
    }, [open]);

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <div className="d-flex justify-content-between" style={{ backgroundColor: "rgb(26 101 129)", color: "white" }}>
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title"
                    >
                        End Point Configuration
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            color: "white",
                        }}
                    >
                        <CloseIcon />
                    </IconButton></div>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        <p>Pull End Point</p>
                        <div >

                            <FormControl sx={commonSx} error={formSubmitted && dropdownRig === ""} required>
                                <InputLabel>Select a Rig</InputLabel>
                                <Select
                                    value={dropdownRig}
                                    onChange={handleRigChange}
                                    label="Select a Rig"
                                >
                                    {Object.keys(rigWellData).map((rig) => (
                                        <MenuItem key={rig} value={rig}>
                                            {rig}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {formSubmitted && dropdownRig === "" && (
                                    <FormHelperText>Rig is required</FormHelperText>
                                )}
                            </FormControl>



                            <FormControl sx={commonSx} error={formSubmitted && selectedWell === ""} required>
                                <InputLabel>Select a Well</InputLabel>
                                <Select value={selectedWell} onChange={handleWellChange} label="Select a Well">
                                    {rigWellData[dropdownRig]?.map((well) => (
                                        <MenuItem key={well} value={well}>
                                            {well}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {formSubmitted && selectedWell === "" && (
                                    <FormHelperText>Well is required</FormHelperText>
                                )}
                            </FormControl>



                            <FormControl sx={commonSx} error={formSubmitted && selectedDataProvider === ""} required>
                                <InputLabel>Select a Data Provider</InputLabel>
                                <Select value={selectedDataProvider} onChange={handleDataProviderChange} label="Select a Data Provider">
                                    {wellProviderData[selectedWell]?.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {formSubmitted && selectedDataProvider === "" && (
                                    <FormHelperText>DataProvider is required</FormHelperText>
                                )}
                            </FormControl>

                        </div>
                        <hr />
                        <p>Push End Point</p>

                        <div>

                            <FormControl sx={commonSx} error={formSubmitted && EndPoint.endPointType === ""} required>
                                <InputLabel>End Point Type</InputLabel>
                                <Select name="endPointType" value={EndPoint.endPointType} onChange={handleChange} label="Select a End Point">
                                    {EndPointType?.map((endpointtype) => (
                                        <MenuItem key={endpointtype} value={endpointtype}>
                                            {endpointtype}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {formSubmitted && EndPoint.endPointType === "" && (
                                    <FormHelperText>EndPointType is required</FormHelperText>
                                )}
                            </FormControl>

                            {EndPoint.endPointType === 'YellowHammer' ?
                                (
                                    <>
                                        <FormControl sx={commonSx} error={formSubmitted && EndPoint.isSecure === ""} required>
                                            <InputLabel>Is Secure</InputLabel>
                                            <Select name="isSecure" value={EndPoint.isSecure} onChange={handleChange} label="Is Secure">
                                                {Secure?.map((secure) => (
                                                    <MenuItem key={secure} value={secure}>
                                                        {secure}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {formSubmitted && EndPoint.isSecure === "" && (
                                                <FormHelperText>Secure is required</FormHelperText>
                                            )}
                                        </FormControl>

                                        <TextField
                                            sx={commonSx}
                                            id="host"
                                            name="host"   // Set the name to "host"
                                            label="Host"
                                            variant="outlined"
                                            onChange={handleChange}
                                            value={EndPoint.host}
                                            required
                                            error={
                                                formSubmitted && EndPoint.host === ""
                                            }
                                            helperText={
                                                formSubmitted && EndPoint.host === ""
                                                    ? "Host is required"
                                                    : ""
                                            }
                                        />

                                        <TextField
                                            sx={commonSx}
                                            id="port"
                                            name="port"   // Set the name to "port"
                                            label="Port"
                                            variant="outlined"
                                            onChange={handleChange}
                                            required
                                            error={
                                                formSubmitted && EndPoint.port === ""
                                            }
                                            helperText={
                                                formSubmitted && EndPoint.port === ""
                                                    ? "Port is required"
                                                    : ""
                                            }
                                            value={EndPoint.port}
                                        />

                                        <TextField
                                            sx={commonSx}
                                            id="clientId"
                                            name="clientId"   // Set the name to "clientId"
                                            label="Client Id"
                                            variant="outlined"
                                            onChange={handleChange}
                                            required
                                            value={EndPoint.clientId}
                                            error={
                                                formSubmitted && EndPoint.clientId === ""
                                            }
                                            helperText={
                                                formSubmitted && EndPoint.clientId === ""
                                                    ? "ClientId is required"
                                                    : ""
                                            }
                                        />

                                        <TextField
                                            sx={commonSx}
                                            id="apiKey"
                                            name="apiKey"   // Set the name to "apiKey"
                                            label="API Key"
                                            variant="outlined"
                                            onChange={handleChange}
                                            required
                                            value={EndPoint.apiKey}
                                            error={
                                                formSubmitted && EndPoint.apiKey === ""
                                            }
                                            helperText={
                                                formSubmitted && EndPoint.apiKey === ""
                                                    ? "API Key is required"
                                                    : ""
                                            }
                                        />



                                    </>
                                ) :
                                (
                                    <>
                                        <FormControl sx={commonSx} error={formSubmitted && EndPoint.version === ""} required>
                                            <InputLabel>Version</InputLabel>
                                            <Select name="version" value={EndPoint.version} onChange={handleChange} label="Version">
                                                {Version?.map((ver) => (
                                                    <MenuItem key={ver} value={ver}>
                                                        {ver}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {formSubmitted && EndPoint.version === "" && (
                                                <FormHelperText>Version is required</FormHelperText>
                                            )}
                                        </FormControl>

                                        <FormControl sx={commonSx} >
                                            <InputLabel>Date Format</InputLabel>
                                            <Select name="dateFormat" value={EndPoint.dateFormat} onChange={handleChange} label="dateFormat">
                                                {DateFormat?.map((date) => (
                                                    <MenuItem key={date} value={date}>
                                                        {date}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <TextField
                                            sx={commonSx}
                                            id="url"
                                            name="url"   // Set the name to "host"
                                            label="URL"
                                            variant="outlined"
                                            onChange={handleChange}
                                            required
                                            value={EndPoint.url}
                                            error={
                                                formSubmitted && EndPoint.url === ""
                                            }
                                            helperText={
                                                formSubmitted && EndPoint.url === ""
                                                    ? "URL is required"
                                                    : ""
                                            }
                                        />

                                        <TextField
                                            sx={commonSx}
                                            id="userName"
                                            name="userName"   // Set the name to "port"
                                            label="User Name"
                                            variant="outlined"
                                            onChange={handleChange}
                                            required
                                            value={EndPoint.userName}
                                            error={
                                                formSubmitted && EndPoint.userName === ""
                                            }
                                            helperText={
                                                formSubmitted && EndPoint.userName === ""
                                                    ? "User Name is required"
                                                    : ""
                                            }
                                        />

                                        <TextField
                                            sx={commonSx}
                                            id="password"
                                            name="password"   // Set the name to "clientId"
                                            label="Password"
                                            variant="outlined"
                                            onChange={handleChange}
                                            required
                                            value={EndPoint.password}
                                            error={
                                                formSubmitted && EndPoint.password === ""
                                            }
                                            helperText={
                                                formSubmitted && EndPoint.password === ""
                                                    ? "Password is required"
                                                    : ""
                                            }
                                        />

                                    </>
                                )
                            }

                        </div>

                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        style={{ color: "rgb(26 101 129)" }}
                    >
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSave}
                        style={{
                            backgroundColor: "rgb(26 101 129)",
                            color: "white",
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default SyncServiceDialog;